import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule, inject, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { OAuthModule, OAuthService } from 'angular-oauth2-oidc';
import { environment } from '../environments/environment';
import { initAppAuthFactory } from '../shared/factories';
import { ProgressBarComponent } from '../progress-bar/progress-bar.component';
import { LogOutComponent } from '../app/log-out/log-out.component';
import { AuthenticationErrorHandler } from '../shared/authentication.handler';
 

@NgModule({
  declarations: [
    AppComponent,
    ProgressBarComponent,
    LogOutComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    OAuthModule.forRoot(),
  ],
  providers: [
    provideAppInitializer(() => {
        const initializerFn = (initAppAuthFactory)(inject(OAuthService), inject(Router));
        return initializerFn();
      }),
    {
      provide: ErrorHandler,
      useClass: AuthenticationErrorHandler,
      deps: [OAuthService],
    },
    
  ],
  bootstrap: [AppComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class AppModule { }